export default __webpack_public_path__ + "static/media/14.38311e5b.png";